import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class SetPlaceSourceModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class SetPlaceSourceModalData {
    account: Account;
    constructor(account?) {
        this.account = account;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.place.source/set.place.source.modal.provider.ts